import { render } from "./user.vue?vue&type=template&id=fbde0754&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=fbde0754&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\car\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbde0754"]])

export default __exports__